import { Box, List, SystemIcon, Typography } from '@wishket/design-system';
import { MouseEvent, PropsWithChildren } from 'react';

interface RemovableItemProps {
  text: string;
  onClick: () => void;
  onRemove: () => void;
}

export const RemovableListContainer = ({ children }: PropsWithChildren) => {
  return (
    <Box className="w-full rounded-3xl border-none bg-w-white p-6 pr-1.5 shadow-none">
      <Box className="flex max-h-[194px] flex-col gap-4 overflow-y-auto pr-1.5 scrollbar-list">
        {children}
      </Box>
    </Box>
  );
};

interface DefaultListItemProps {
  onClick: () => void;
}

const DefaultListItem = ({ onClick }: DefaultListItemProps) => {
  return (
    <List.Item
      className="group relative flex h-[26px] max-w-[216px] px-0 hover:bg-transparent"
      onClick={onClick}
    >
      <SystemIcon
        name="medium_question_new"
        className="mr-4 shrink-0 text-primary"
        solid
      />
      <Typography
        variant="body1"
        className="-ml-1 max-w-[184px] truncate text-w-gray-700"
      >
        새로운 질문
      </Typography>
    </List.Item>
  );
};

interface DefaultListProps {
  onClick: () => void;
}

export const DefaultList = ({ onClick }: DefaultListProps) => {
  return (
    <RemovableListContainer>
      <DefaultListItem onClick={onClick} />
    </RemovableListContainer>
  );
};

export const RemovableItem = ({
  text,
  onClick,
  onRemove,
}: RemovableItemProps) => {
  const handleRemove = (e: MouseEvent<HTMLDivElement>) => {
    onRemove();
    e.stopPropagation();
  };

  return (
    <List.Item
      className="group relative flex h-[26px] max-w-[216px] px-0 hover:bg-transparent"
      onClick={onClick}
    >
      <SystemIcon
        name="medium_question"
        className="mr-4 shrink-0 text-primary"
      />
      <Typography
        variant="body1"
        className="-ml-1 max-w-[184px] truncate text-w-gray-700"
      >
        {text}
      </Typography>
      <Box className="invisible absolute right-0 flex items-center justify-center group-hover:visible">
        <div className="h-[26px] w-8 bg-gradient-to-r from-transparent to-white" />
        <Box
          className="flex h-[26px] w-8 items-center justify-end bg-w-white"
          onClick={handleRemove}
        >
          <SystemIcon name="medium_trash" className="text-w-gray-600" />
        </Box>
      </Box>
    </List.Item>
  );
};
